import {HSConsent} from "server-openapi";
import {DateUtils} from "./dateUtils";

export function getConsentDescription(psychotropicConsent: boolean | null | undefined,  consent: HSConsent | null | undefined) {
    if (!psychotropicConsent || !consent) {
        return null;
    }

    const date = getDate(consent.date);
    if (!date) {
        return null;
    }

    const personResponsible = consent.personResponsible?.trim();
    const relationship = consent.relationship?.trim();
    const comments = consent.comments?.trim();

    let text = "Psychotropic consent";
    if (consent.byConsumer) {
        text += " by Consumer";
    } else if (personResponsible) {
        text += " by " + personResponsible;
        if (relationship) {
            text += " (" + relationship + ")";
        }
    } else if (relationship) {
        text += " by " + relationship;
    }
    if (date) {
        text += " on " + DateUtils.toDisplayDateString(date);
    }
    if (comments) {
        text += ": " + comments;
    }

    return text;
}

function getDate(text: string | null | undefined): Date | null | undefined {
    try {
        if (text) {
            // This handles the case where we receive an invalid date from HS,
            // for example 0001-01-01
            const date = DateUtils.toDate(text);
            if (date.getFullYear() < 2000) {
                return null;
            }
        }
    } catch {
        // invalid date text
    }
    return null;

}
